import React from 'react';
import AddTeamMember from '../components/team/AddTeamMember';
import CreateTeam from '../components/team/CreateTeam';
import TeamsTable from '../components/team/TeamsTable';
import { CapexResourcesTable } from '../components/templates/CapexesTable';
import { TemplateCropsTable } from '../components/templates/CropsTable';
import { EditCapexResource } from '../components/templates/EditCapex';
import { EditTemplateCropSettings } from '../components/templates/EditCropSettings';
import { EditFuelPricingResource } from '../components/templates/EditFuel';
import { EditInputResource } from '../components/templates/EditInput';
import { InputResourcesTable } from '../components/templates/InputsTable';
import AdminTeamView from '../views/AdminTeamView';
import BreadcrumbLayout from '../layouts/BreadcrumbLayout';
import { cropTabRoutes, TemplateCropTabLayout } from '../layouts/CropTabLayout';
import PageLayout from '../layouts/PageLayout';
import SuperadminFarmsTable from '../components/farm/SuperadminFarmsTable';
import NewFarm from '../components/farm/NewFarm';
import { FarmsQuery } from '../queries';
import SuperadminFarmSettings from '../components/farm/SuperadminFarmSettings';
import SuperadminBillingReport from '../components/farm/SuperadminBillingReport';
import UsersTable from '../components/user/UsersTable';
import InviteUser from '../components/user/InviteUser';
import EditUser from '../components/user/EditUser';
import SuperadminLayout from '../layouts/SuperadminLayout';
import PortfolioEvaluatorView from '../views/PortfolioEvaluatorView';
import DevRoutes from './DevRoutes';
import LandAdvisorView from '../views/LandAdvisorView';

const SuperadminRoutes = {
  path: 'superadmin',
  element: <SuperadminLayout />,
  children: [
    DevRoutes,
    // Portfolio evaluator does not use the PageLayout
    {
      path: 'portfolio-evaluator',
      element: <PortfolioEvaluatorView />,
    },
    // Land advisor does not use the PageLayout
    {
      path: 'land-advisor',
      element: <LandAdvisorView />,
    },
    {
      element: <PageLayout />,
      children: [
        {
          path: 'farms',
          element: (
            <BreadcrumbLayout rootUrl="/superadmin/farms" rootText="Farms" />
          ),
          children: [
            {
              index: true,
              element: <SuperadminFarmsTable />,
            },
            {
              path: 'new',
              element: <NewFarm refetchQuery={FarmsQuery} showBreadcrumbs />,
            },
            {
              path: ':farmId/edit',
              element: <SuperadminFarmSettings />,
            },
          ],
        },
        {
          path: 'users',
          element: (
            <BreadcrumbLayout rootUrl="/superadmin/users" rootText="Users" />
          ),
          children: [
            {
              index: true,
              element: <UsersTable />,
            },
            {
              path: 'new',
              element: <InviteUser />,
            },
            {
              path: ':id/edit',
              element: <EditUser showBreadcrumbs />,
            },
          ],
        },
        {
          path: 'teams',
          element: (
            <BreadcrumbLayout rootUrl="/superadmin/teams" rootText="Teams" />
          ),
          children: [
            {
              index: true,
              element: <TeamsTable />,
            },
            {
              path: 'new',
              element: <CreateTeam />,
            },
            {
              path: ':teamId/members',
              element: <AdminTeamView />,
            },
            {
              path: ':teamId/members/new',
              element: <AddTeamMember />,
            },
          ],
        },
        {
          path: 'templates',
          element: (
            <BreadcrumbLayout
              rootUrl="/superadmin/templates"
              rootText="Crop Templates"
            />
          ),
          children: [
            {
              index: true,
              element: <TemplateCropsTable />,
            },
            {
              path: ':id',
              element: <TemplateCropTabLayout />,
              children: cropTabRoutes({
                componentAccessor: 'templateComponent',
                IndexComponent: EditTemplateCropSettings,
              }),
            },
            {
              path: 'new',
              element: <EditTemplateCropSettings />,
            },
          ],
        },
        {
          path: 'capexes',
          element: (
            <BreadcrumbLayout
              rootUrl="/superadmin/capexes"
              rootText="Capexes"
            />
          ),
          children: [
            {
              index: true,
              element: <CapexResourcesTable />,
            },
            {
              path: 'new',
              element: <EditCapexResource />,
            },
            {
              path: ':id/edit',
              element: <EditCapexResource />,
            },
          ],
        },
        {
          path: 'inputs',
          element: <BreadcrumbLayout />,
          children: [
            {
              index: true,
              element: <InputResourcesTable />,
            },
            {
              path: 'new',
              element: <EditInputResource />,
            },
            {
              path: ':id/edit',
              element: <EditInputResource />,
            },
            {
              path: 'pricing/new',
              element: <EditFuelPricingResource />,
            },
            {
              path: 'pricing/:id/edit',
              element: <EditFuelPricingResource />,
            },
          ],
        },
        {
          path: 'billing-report',
          element: <BreadcrumbLayout rootText="Billing Report" />,
          children: [
            {
              index: true,
              element: <SuperadminBillingReport />,
            },
          ],
        },
      ],
    },
  ],
};

export default SuperadminRoutes;
